export default __webpack_public_path__ + "static/download-3f82a55a8e551d8571f7c605a216227c.png";